export default "__VITE_ASSET__DjpD6ahN__"